import { CustomTheme } from '../../../../lib/utils/CustomTheme';
const { desktop } = CustomTheme.mediaQueries;
export const pageStyles = {
    h1: {
        fontSize: '1.75rem',
        fontFamily: 'Avenir-Black',
        lineHeight: '2.25rem',
    },
    '.subtitle': {
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
    },
    '.content': {
        padding: '1.5rem', // 24px to rem
        h2: {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
            marginBottom: '1rem', // 16px to rem
        },
        '.info': {
            display: 'flex',
            flexDirection: 'column',
            gap: '2.5rem', // 16px to rem
            hr: {
                backgroundColor: CustomTheme.special.hr,
                border: 0,
                height: '0.0625rem', // 1px to rem
                margin: 0,
            },
        },
        '.disclaimer': {
            display: 'flex',
            alignItems: 'start',
            span: {
                paddingTop: '0',
            },
        },
    },
    [desktop]: {
        h1: {
            // 32px to rem
            fontSize: '2rem',
            lineHeight: '2.5rem',
        },
        '.subtitle': {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
        },
        '.content': {
            // maxWidth 342 px to rem
            padding: 0,
            maxWidth: '32.5rem', // 425px to rem
            margin: '2.5rem', // 40px to rem
            h2: {
                marginBottom: '1.5rem', // 24px to rem
            },
            '.top': {
                gap: '2.5rem', // 40px to rem
            },
            '.list-grid-container': {
                marginTop: '2.5rem', // 40px to rem
            },
        },
    },
};
